import type { Node } from 'slate';

import { Element } from 'slate';

import type { ParagraphElement } from '@ui/MarkdownEditor/types';

export const type = 'paragraph';
export const isParagraph = (node: Node): node is ParagraphElement => Element.isElementType(node, type);
